var CtaBuilderComponent = {
  name: '_Cta_',
  image: 'https://cdn.builder.io/api/v1/image/assets%2FIsxPKMo2gPRRKeakUztj1D6uqed2%2F81a15681c3e74df09677dfc57a615b13',
  noWrap: true,
  inputs: [{
    name: 'variant',
    type: 'string',
    "enum": ['primary', 'secondary', 'other', 'text_link'],
    defaultValue: 'primary'
  }, {
    name: 'text',
    type: 'string',
    defaultValue: 'Click me!',
    localized: true
  }, {
    name: 'link',
    type: 'string',
    defaultValue: '/',
    localized: true
  }]
};
export default CtaBuilderComponent;